/*
 * Common Messages
 *
 * This contains all the text that is common to both containers and components.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  achTotals: {
    id: 'sentinel.common.achTotals',
    defaultMessage: 'ACH Totals',
  },
  nachaReturns: {
    id: 'sentinel.common.nachaReturns',
    defaultMessage: 'NACHA Returns',
  },
  processNavTitle: {
    id: 'sentinel.common.processNavTitle',
    defaultMessage: 'Process',
  },
  reportsNavTitle: {
    id: 'sentinel.common.reportsNavTitle',
    defaultMessage: 'Reports',
  },
  searchAndProcessS2: {
    id: 'sentinel.common.searchAndProcessS2',
    defaultMessage: 'Search & Process S2',
  },
  transferReviewRoleMyQueue: {
    id: 'sentinel.common.transferReviewRoles.myQueue',
    defaultMessage: 'My Queue',
  },
  transferReviewRoleMyRole: {
    id: 'sentinel.common.transferReviewRoles.myRole',
    defaultMessage: 'My Role',
  },
  transferReviewRoleAll: {
    id: 'sentinel.common.transferReviewRoles.all',
    defaultMessage: 'All',
  },
  transferDirectionDeposit: {
    id: 'sentinel.common.transferDirection.deposit',
    defaultMessage: 'Deposit',
  },
  transferDirectionWithdrawal: {
    id: 'sentinel.common.transferDirection.withdrawal',
    defaultMessage: 'Withdrawal',
  },
  transferDirectionJournal: {
    id: 'sentinel.common.transferDirection.journal',
    defaultMessage: 'Journal',
  },
  transferMechanismAch: {
    id: 'sentinel.common.transferMechanism.ach',
    defaultMessage: 'ACH',
  },
  transferMechanismWire: {
    id: 'sentinel.common.transferMechanism.wire',
    defaultMessage: 'Wire',
  },
  transferMechanismCheck: {
    id: 'sentinel.common.transferMechanism.check',
    defaultMessage: 'Check',
  },
  transferStateReviewPending: {
    id: 'sentinel.common.transferState.reviewPending',
    defaultMessage: 'Review Pending',
  },
  transferStateReviewRequired: {
    id: 'sentinel.common.transferState.reviewRequired',
    defaultMessage: 'Review Required',
  },
  transferStateSentToBank: {
    id: 'sentinel.common.transferState.sentToBank',
    defaultMessage: 'Sent to Bank',
  },
  transferStateSendToBankFailed: {
    id: 'sentinel.common.transferState.sendToBankFailed',
    defaultMessage: 'Send to Bank Failed',
  },
  transferStateRejectedNotSentToBank: {
    id: 'sentinel.common.transferState.rejectedNotSentToBank',
    defaultMessage: 'Rejected - Not Sent to Bank',
  },
  transferStateApproved: {
    id: 'sentinel.common.transferState.approved',
    defaultMessage: 'Approved',
  },
  transferStateFundsReturned: {
    id: 'sentinel.common.transferState.fundsReturned',
    defaultMessage: 'Funds Returned',
  },
  transferStateReturned: {
    id: 'sentinel.common.transferState.returned',
    defaultMessage: 'Returned',
  },
  transferStateRejected: {
    id: 'sentinel.common.transferState.rejected',
    defaultMessage: 'Rejected',
  },
  transferStateRejectedUnapproved: {
    id: 'sentinel.common.transferState.rejectedUnapproved',
    defaultMessage: 'Rejected - Unapproved',
  },
  transferStateRejectedFundsNotPosted: {
    id: 'sentinel.common.transferState.rejectedFundsNotPosted',
    defaultMessage: 'Rejected - Funds Not Posted',
  },
  transferStateRejectedPositionNotPosted: {
    id: 'sentinel.common.transferState.rejectedPositionNotPosted',
    defaultMessage: 'Rejected - Position Not Posted',
  },
  transferStatePendingPrinting: {
    id: 'sentinel.common.transferState.pendingPrinting',
    defaultMessage: 'Pending Printing',
  },
  transferStateRejectedValidationFailed: {
    id: 'sentinel.common.transferState.rejectedValidationFailed',
    defaultMessage: 'Rejected - Validation Failed',
  },
  transferStateFundsPosted: {
    id: 'sentinel.common.transferState.fundsPosted',
    defaultMessage: 'Funds Posted',
  },
  transferStatePositionPosted: {
    id: 'sentinel.common.transferState.PositionPosted',
    defaultMessage: 'Position Posted',
  },
  transferStateCompleted: {
    id: 'sentinel.common.transferState.completed',
    defaultMessage: 'Completed',
  },
  transferStatePostponed: {
    id: 'sentinel.common.transferState.postponed',
    defaultMessage: 'Postponed',
  },
  transferStateCanceled: {
    id: 'sentinel.common.transferState.canceled',
    defaultMessage: 'Canceled',
  },
  transferStateStoppedPayment: {
    id: 'sentinel.common.transferState.stoppedPayment',
    defaultMessage: 'Stopped Payment',
  },
  transferStateSuspended: {
    id: 'sentinel.common.transferState.suspended',
    defaultMessage: 'Suspended',
  },
  transferStateWireDepositDetails: {
    id: 'sentinel.common.transferState.WireDepositDetails',
    defaultMessage: 'Wire Deposit Details Added',
  },
  transferStateAnalyzing: {
    id: 'sentinel.common.transferState.analyzing',
    defaultMessage: 'Analyzing',
  },
  transferStateValidating: {
    id: 'sentinel.common.transferState.validating',
    defaultMessage: 'Validating',
  },
  transferStateSuspendedPendingReturn: {
    id: 'sentinel.common.transferState.SuspendedPendingReturn',
    defaultMessage: 'Suspended Pending Return',
  },
  transferStateReturnedWaitingForReversal: {
    id: 'sentinel.common.transferState.ReturnedWaitingReversal',
    defaultMessage: 'Returned Waiting for Reversal',
  },
  transferStateFailedAtBank: {
    id: 'sentinel.common.transferState.FailedAtBank',
    defaultMessage: 'Failed at Bank',
  },
  transferStateVoided: {
    id: 'sentinel.common.transferState.StateVoided',
    defaultMessage: 'Voided',
  },
  transferStateFailedToSuspend: {
    id: 'sentinel.common.transferState.FailedToSuspend',
    defaultMessage: 'Failed to Suspend',
  },
  transferStatePayPalReviewPending: {
    id: 'sentinel.common.transferState.PayPalReviewPending',
    defaultMessage: 'PayPal Review Pending',
  },
  transferStateInvestorReviewPending: {
    id: 'sentinel.common.transferState.InvestorReviewPending',
    defaultMessage: 'Investor Review Pending',
  },
  transferStatePaymentScheduled: {
    id: 'sentinel.common.transferState.PaymentScheduled',
    defaultMessage: 'Payment Scheduled',
  },
  transferStateSentToRtpNetwork: {
    id: 'sentinel.common.transferState.SentToRtpNetwork',
    defaultMessage: 'Sent to RTP Network',
  },
  BPO_IRA_ANALYST: {
    id: 'sentinel.common.transferState.BPO_IRA_ANALYST',
    defaultMessage: 'BPO IRA Analyst',
  },
  BPO_MARGIN_ANALYST: {
    id: 'sentinel.common.transferState.BPO_MARGIN_ANALYST',
    defaultMessage: 'BPO Margin Analyst',
  },
  APEX_IRA_ANALYST: {
    id: 'sentinel.common.transferState.APEX_IRA_ANALYST',
    defaultMessage: 'Apex IRA Analyst',
  },
  BPO_BANKING_ANALYST: {
    id: 'sentinel.common.transferState.BPO_BANKING_ANALYST',
    defaultMessage: 'BPO Banking Analyst',
  },
  APEX_MARGIN_ANALYST: {
    id: 'sentinel.common.transferState.APEX_MARGIN_ANALYST',
    defaultMessage: 'Apex Margin Analyst',
  },
  APEX_MARGIN_MANAGER: {
    id: 'sentinel.common.transferState.APEX_MARGIN_MANAGER',
    defaultMessage: 'Apex Margin Manager',
  },
  APEX_MARGIN_DIRECTOR: {
    id: 'sentinel.common.transferState.APEX_MARGIN_DIRECTOR',
    defaultMessage: 'Apex Margin Director',
  },
  APEX_RISK_MANAGEMENT: {
    id: 'sentinel.common.transferState.APEX_RISK_MANAGEMENT',
    defaultMessage: 'Apex Risk Management',
  },
  APEX_BANKING: {
    id: 'sentinel.common.transferState.APEX_BANKING',
    defaultMessage: 'Apex Banking',
  },
  APEX_EXECUTIVE_MANAGEMENT: {
    id: 'sentinel.common.transferState.APEX_EXECUTIVE_MANAGEMENT',
    defaultMessage: 'Apex Executive Management',
  },
  APEX_COMPLIANCE: {
    id: 'sentinel.common.transferState.APEX_COMPLIANCE',
    defaultMessage: 'Apex Compliance',
  },
  APEX_LEGAL: {
    id: 'sentinel.common.transferState.APEX_LEGAL',
    defaultMessage: 'Apex Legal',
  },
  APEX_ACATS: {
    id: 'sentinel.common.transferState.APEX_ACATS',
    defaultMessage: 'Apex Acats',
  },
  APEX_NEW_ACCOUNTS: {
    id: 'sentinel.common.transferState.APEX_NEW_ACCOUNTS',
    defaultMessage: 'Apex New Accounts',
  },
});



// WEBPACK FOOTER //
// ./src/common/messages.js